// 飞书信息收集表，站内所有「联系我们」入口都指向这里。
export const CONTACT_FORM_URL =
  "https://ffaninfo.feishu.cn/share/base/form/shrcn9fJSSnOGORZVBmNfQdIPsf";
